export default "__VITE_ASSET__XrbTcnJT__"